import { render, staticRenderFns } from "./oftenGoodsFill.vue?vue&type=template&id=1a59b42e&scoped=true&"
import script from "./oftenGoodsFill.vue?vue&type=script&lang=js&"
export * from "./oftenGoodsFill.vue?vue&type=script&lang=js&"
import style0 from "./oftenGoodsFill.vue?vue&type=style&index=0&id=1a59b42e&scoped=true&lang=scss&"
import style1 from "./oftenGoodsFill.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a59b42e",
  null
  
)

export default component.exports